/*
 * assets/hair-advisor-summary.js — AEVIA Hair Advisor, results summary
 * (Phase 1 professional copy, 2026-10-08).
 * READ-ONLY companion of assets/hair-advisor.js: it never scores, filters,
 * orders or moves products. When the results panel becomes visible it
 * reads (1) the answers already present in the form and (2) which routine
 * steps hair-advisor.js already revealed, and writes them as plain text
 * into the ANALISI / ESIGENZA / OBIETTIVO / PERCORSO placeholders.
 */
(function () {
  "use strict";
  var root = document.querySelector("[data-aevia-hair-advisor]");
  if (!root) return;
  var form = root.querySelector("[data-aevia-form]");
  var results = root.querySelector("[data-aevia-results]");
  if (!form || !results) return;

  // Selection order of Q2 (the first checked is the main one).
  var order = [];
  form.addEventListener("change", function (e) {
    var t = e.target;
    if (!t || t.name !== "problema") return;
    var i = order.indexOf(t.value);
    if (t.checked) { if (i < 0) order.push(t.value); }
    else if (i >= 0) order.splice(i, 1);
  });
  var restart = root.querySelector("[data-aevia-restart]");
  if (restart) restart.addEventListener("click", function () { order = []; });

  function label(v) {
    var s = String(v).replace(/-/g, " ");
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  function checked(name) {
    return Array.prototype.slice.call(form.querySelectorAll('input[name="' + name + '"]:checked'))
      .map(function (i) { return i.value; });
  }
  function yesNo(name) {
    var c = checked(name);
    if (!c.length) return "";
    return c[0] === "yes" ? "Sì" : "No";
  }
  function setBlock(blockSel, valueSel, text) {
    var block = results.querySelector(blockSel);
    var el = results.querySelector(valueSel);
    if (!block || !el) return;
    el.textContent = text;
    block.hidden = !text;
  }

  function render() {
    var type = checked("tipo_capello")[0] || "";
    var probs = checked("problema");
    var ranked = order.filter(function (v) { return probs.indexOf(v) > -1; });
    probs.forEach(function (v) { if (ranked.indexOf(v) < 0) ranked.push(v); });

    var rows = [];
    if (type) rows.push(["Tipo di capello", label(type)]);
    if (ranked[0]) rows.push(["Criticità principale", label(ranked[0])]);
    if (ranked[1]) rows.push(["Criticità secondaria", label(ranked[1])]);
    var poro = yesNo("porosita");
    if (poro) rows.push(["Assorbe e torna secco", poro]);
    var heat = yesNo("calore");
    if (heat) rows.push(["Strumenti di calore", heat]);
    if (type === "ricci" || type === "molto-ricci") {
      var curl = yesNo("definizione_ricci");
      if (curl) rows.push(["Definizione del riccio", curl]);
    }

    var dl = results.querySelector("[data-aevia-summary-analysis]");
    if (dl) {
      while (dl.firstChild) dl.removeChild(dl.firstChild);
      rows.forEach(function (r) {
        var wrap = document.createElement("div");
        wrap.className = "aevia-ha-summary__fact";
        var dt = document.createElement("dt");
        dt.className = "aevia-caption";
        dt.textContent = r[0];
        var dd = document.createElement("dd");
        dd.textContent = r[1];
        wrap.appendChild(dt);
        wrap.appendChild(dd);
        dl.appendChild(wrap);
      });
    }

    var need = checked("esigenza")[0] || "";
    setBlock("[data-aevia-summary-need-block]", "[data-aevia-summary-need]", need ? label(need) : "");
    setBlock("[data-aevia-summary-goals-block]", "[data-aevia-summary-goals]", checked("obiettivo").map(label).join(", "));

    // Steps hair-advisor.js already revealed, in their DOM (ritual) order.
    var steps = Array.prototype.slice.call(results.querySelectorAll("[data-aevia-routine-step]"))
      .filter(function (s) { return !s.hidden; })
      .map(function (s) {
        var t = s.querySelector("h3");
        return t ? t.textContent.trim() : "";
      })
      .filter(Boolean);
    var phaseTitle = results.querySelector("[data-aevia-summary-phase-title]");
    if (phaseTitle) phaseTitle.hidden = steps.length === 0;
    var pathBlock = results.querySelector("[data-aevia-summary-path-block]");
    var path = results.querySelector("[data-aevia-summary-path]");
    if (path && pathBlock) {
      while (path.firstChild) path.removeChild(path.firstChild);
      steps.forEach(function (name) {
        var li = document.createElement("li");
        li.textContent = name;
        path.appendChild(li);
      });
      pathBlock.hidden = steps.length === 0;
    }
  }

  new MutationObserver(function () {
    if (!results.hidden) window.setTimeout(render, 0);
  }).observe(results, { attributes: true, attributeFilter: ["hidden"] });
})();
